import { Modal } from "bootstrap";
import Cookies from "js-cookie";
import "./highlight";
window.Modal = Modal;
window.Cookies = Cookies;

(function ($) {
  var product_category_array = [];
  var product_category_array_with_names = [];

  // On Dom Ready
  $(function () {
    // check for query string in url to get search result
    fetch_resources_from_url();

    // Keyword auto-suggestion feature
    $("#resource_keyword").on("keyup", function (e) {
      var keyword = $(this).val();
      if (keyword) {
        $.ajax({
          type: "post",
          url: ajax_var.url,
          data: {
            action: "get_resources_autocomplete",
            nonce: ajax_var.nonce,
            keyword: keyword,
          },
          success: function success(response) {
            $("#resource_suggestion").html(response);
            $("#resource_suggestion").highlight(keyword);
          },
        });
      } else {
        $("#resource_suggestion").html("");
      }
    });

    $("#resource_keyword").on("blur", function (e) {
      setTimeout(() => {
        $("#resource_suggestion").hide();
      }, 300);
    });

    $("#resource_keyword").on("focus", function (e) {
      $("#resource_suggestion").show();
    });

    // Filter By Resource Type
    $(document).on("click", ".resource-type-link", function (e) {

      // Ignore Resource Types with Custom Links, allow those to function normally
      if( $(this).attr('href') !== '#' ){
        return;
      }

      e.preventDefault();
      var resource_type = $(this).data("resource-type");
      var product_category = ""; // reset product category, since user has changed resource type

      product_category_array = [];

      update_resource_type_links_in_sidebar(resource_type);

      // reset all product category filters
      $(".resource-filters .the-filter ul.parent-links li a.product-category-link").parent(".active").removeClass("active").next(".child-links").slideUp();
      $(".resource-filters .the-filter ul.parent-links li a.product-category-link").removeClass("active");

      get_resource_search_result(resource_type, product_category);

      // update url
      const url = new URL(window.location);
      url.searchParams.delete("resource_id");
      url.searchParams.delete("keyword");
      url.searchParams.delete("product_category");
      url.searchParams.set("resource_type", resource_type);
      window.history.pushState({}, "", url);
      $("#resource_keyword").val();

      var resource_type_qs = getQueryString("resource_type");

      if (!resource_type_qs) {
        reset_page();
      }
    });

    // Filter by Product Category
    $(document).on("click", ".product-category-link", function (e) {
      e.preventDefault();
      var resource_type = getQueryString("resource_type");

      var product_category = $(this).data("product-category");
      if (product_category_array.includes(product_category)) {
        var index = product_category_array.indexOf(product_category);
        if (index !== -1) {
          product_category_array.splice(index, 1);
        }
      } else {
        product_category_array.push(product_category);
      }

      get_resource_search_result(resource_type, product_category_array);

      $(this).toggleClass("active");

      // update url
      const url = new URL(window.location);
      url.searchParams.delete("keyword");
      url.searchParams.delete("resource_id");

      if (product_category_array.length > 0) {
        url.searchParams.set("product_category", product_category_array.join(",").toString());
      } else {
        url.searchParams.delete("product_category");
      }
      window.history.pushState({}, "", url);

      $("#resource_keyword").val();

      var resource_type_qs = getQueryString("resource_type");
      var product_category_qs = getQueryString("product_category");

      if (!resource_type_qs && !product_category_qs) {
        reset_page();
      }
    });

    // Filter by Autocomplete Resource
    $(document).on("click", ".resource-link", function (e) {
      e.preventDefault();
      var resource_id = $(this).data("resource-id");

      get_resource_from_id(resource_id);

      // update url
      const url = new URL(window.location);
      url.searchParams.delete("resource_type");
      url.searchParams.delete("product_category");
      url.searchParams.delete("keyword");
      url.searchParams.set("resource_id", resource_id);
      window.history.pushState({}, "", url);
    });

    // Search using keyword submission
    $("#resources_search_form").on("submit", function (e) {
      e.preventDefault();
      submit_search_form();
    });
    $("#resource_keyword").on("search", function (e) {
      e.preventDefault();
      if ($("#resource_keyword").val() == "") {
        reset_page();
      }
    });

    // Resource search result expand/collapse
    $(document).on("click", ".resource-type-search-result .resource-type-group .group-title, .resource-type-search-result .the-resource .resource-title", function (e) {
      e.preventDefault();
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });

    // Load modal when clicked on resource link
     jQuery('#leadgenModal').modal({
       show: false
     });
    $(document).on("click", ".resource-download-link, .resource-download-link-icon", function (e) {
      var resource_title = $(this).data("title");
      var download_url = $(this).data("url");

      // Ungated link
      if( typeof download_url === 'undefined' ){
        return;
      }

      e.preventDefault();
      
      // If "leadgen" cookie is set, open file link instead of lead gen form
      if (Cookies.get("leadgen")) {
        if (download_url) {
          window.open(download_url, "_blank");
        }
        // "leadgen" cookie is not set, open lead gen form in lightbox
      } else {
        jQuery('#leadgenModal').modal('show');
        $.ajax({
          type: "post",
          url: ajax_var.url,
          data: {
            action: "get_leadgen_form",
            nonce: ajax_var.nonce,
            resource_title: resource_title,
          },
          success: function success(response) {
            if (response) {
              $(".leadgen-modal-content").html(response);
              document.querySelectorAll(".wpcf7 > form").forEach(function (e) {
                return wpcf7.init(e);
              });
              $("#leadgenModal input[name='downloadurl']").val(download_url);
            }
          },
        });
      }
    });

    $(document).on("click", ".preview-thumb", function (e) {
      e.preventDefault();
      $(".imagepreview").attr("src", $(this).data("preview"));
      $("#imagemodal").modal("show");
    });
  });

  // When clicked back/prev button of browsers
  window.addEventListener("popstate", function (event) {
    fetch_resources_from_url();
  });

  // Submit search form
  function submit_search_form() {
    var keyword = $("#resource_keyword").val();
    get_resource_from_keyword(keyword);

    // update url
    const url = new URL(window.location);
    url.searchParams.delete("resource_type");
    url.searchParams.delete("product_category");
    url.searchParams.delete("resource_id");
    url.searchParams.set("keyword", keyword);
    window.history.pushState({}, "", url);
  }

  // Get resource type intro
  function get_resource_type_intro(resource_type) {
    $.ajax({
      type: "post",
      url: ajax_var.url,
      data: {
        action: "get_resource_type_intro",
        nonce: ajax_var.nonce,
        resource_type: resource_type,
      },
      success: function success(response) {
        if (response) {
          $(".search-wrapper").addClass("results-found");
          $(".resource-type-intro").html(response);
          $(".resource-type-intro").show();
        } else {
          $(".resource-type-intro").html("");
          $(".search-wrapper").removeClass("results-found");
          $(".resource-type-intro").hide();
        }
      },
    });
  }

  // Update selected filters list
  function update_selected_filters_list(product_category_array) {
    let content = "";
    //product_category_array_with_names;
    product_category_array.forEach((product_category) => {
      let found = product_category_array_with_names.find((el) => {
        return el.slug == product_category;
      });

      content += `<li>
					<a href="#" title="delete filter" data-filter="${product_category}">
						${found.name} <span>x</span>
					</a>
				</li>`;
    });
    $("ul.selected-filters").html(content);
  }

  // Delete filter on top when clicked
  $(document).on("click", "ul.selected-filters li a", function (e) {
    e.preventDefault();
    var product_category = $(this).data("filter");
    $(document).find(`.product-category-link[data-product-category='${product_category}']`).trigger("click");
  });

  // Get resource search result
  function get_resource_search_result(resource_type, product_category) {
    $(".resources-page-intro").hide();
    $(".resource-types-grid").hide();
    $(".search-wrapper").addClass("results-found");
    $(".resources-search-result-wrapper").addClass("please-wait");

    get_resource_type_intro(resource_type);
    update_selected_filters_list(product_category_array);

    $.ajax({
      type: "post",
      url: ajax_var.url,
      data: {
        action: "get_resource_search_result",
        nonce: ajax_var.nonce,
        resource_type: resource_type,
        product_category: product_category,
      },
      success: function success(response) {
        if (response) {
          $(".resource-type-search-result").html(response);
          $(".resource-type-search-result").show();
        } else {
          $(".resource-type-search-result").html("");
          $(".resource-type-search-result").hide();
        }
        $(".resources-search-result-wrapper").removeClass("please-wait");
      },
    });
  }

  // Get resource from id
  function get_resource_from_id(resource_id) {
    $(".resources-page-intro").hide();
    $(".resource-types-grid").hide();
    $(".search-wrapper").addClass("results-found");

    $.ajax({
      type: "post",
      url: ajax_var.url,
      data: {
        action: "get_single_resource",
        nonce: ajax_var.nonce,
        resource_id: resource_id,
      },
      success: function success(response) {
        if (response) {
          $(".resource-type-search-result").html(response);
          $(".resource-type-search-result").show();
        } else {
          $(".resource-type-search-result").html("");
          $(".resource-type-search-result").hide();
        }
      },
    });
  }

  // Get resource from keyword
  function get_resource_from_keyword(keyword) {
    $(".resources-page-intro").hide();
    $(".resource-types-grid").hide();
    $("#resource_suggestion").hide();
    $(".search-wrapper").addClass("results-found");
    $(".resources-search-result-wrapper").addClass("please-wait");

    $.ajax({
      type: "post",
      url: ajax_var.url,
      data: {
        action: "get_resources_from_keyword",
        nonce: ajax_var.nonce,
        keyword: keyword,
      },
      success: function success(response) {
        if (response) {
          $(".resource-type-search-result").html(response);
          $(".resource-type-search-result").show();
        } else {
          $(".resource-type-search-result").html("");
          $(".resource-type-search-result").hide();
        }
        $(".resources-search-result-wrapper").removeClass("please-wait");
      },
    });
  }

  // Update resources search result by checking parameters in url
  function fetch_resources_from_url() {
    if ($("body").hasClass("page-template-resources-page")) {
      //create array of all product categories
      $(".product-category-link").each(function (index, element) {
        product_category_array_with_names.push({
          name: $(element).data().productCategoryName,
          slug: $(element).data().productCategory,
        });
      });

      var resource_type_qs = getQueryString("resource_type");
      var product_category_qs = getQueryString("product_category");
      if (product_category_qs.length > 0) {
        product_category_array = product_category_qs.split(",");

        $(".resource-filters .the-filter ul.parent-links li a.product-category-link").removeClass("active");
        $(".resource-filters .the-filter ul.parent-links li a.product-category-link").each(function (index, element) {
          if (product_category_array.includes($(element).data("product-category"))) {
            $(element).addClass("active");
            $(element).parent().parent().slideDown();
            $(element).parent().parent().prev().addClass("active");
          }
        });
      }

      update_resource_type_links_in_sidebar(resource_type_qs);

      var resource_id = getQueryString("resource_id");
      var keyword = getQueryString("keyword");

      if (resource_id) {
        get_resource_from_id(resource_id);
      } else if (keyword) {
        get_resource_from_keyword(keyword);
      } else if (resource_type_qs || product_category_qs) {
        get_resource_search_result(resource_type_qs, product_category_array);
      } else {
        reset_page();
      }
    }
  }

  // Update resource type links in sidebar
  function update_resource_type_links_in_sidebar(resource_type) {
    //console.log({ resource_type });
    // add active class so we can hide it from sidebar
    $(".resource-types-grid--sidebar .resource-type-link").each(function (index, element) {
      $(element).parent().removeClass("active");
    });

    if (resource_type) {
      $(`.resource-types-grid--sidebar .resource-type-link[data-resource-type='${resource_type}']`).parent().addClass("active");
      $(".resource-types-grid--sidebar").removeClass("d-none");
    } else {
      $(".resource-types-grid--sidebar").addClass("d-none");
    }
  }

  // helper function to reset page state
  function reset_page() {
    $(".search-wrapper").removeClass("results-found");

    $(".resources-page-intro").show();
    $(".resource-types-grid").show();

    $(".resource-type-intro").html("");
    $(".resource-type-intro").hide();

    $(".resource-type-search-result").html("");
    $(".resource-type-search-result").hide();
  }

  // helper function to get querystring
  function getQueryString(name, url = window.location.href) {
    var name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return "";
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
})(jQuery);
